import { useEffect } from "react";

import {
  FetchCollectionsAllQueryResult,
  useFetchCollectionsAllQuery,
} from "@src/generated-2026-07";
import { withShopifyGraphqlVersion } from "@src/graphql/shopifyApiVersion";

export function useFetchAllCollections() {
  const queryResult: FetchCollectionsAllQueryResult =
    useFetchCollectionsAllQuery(
      withShopifyGraphqlVersion({ variables: { endCursor: null } }, "2026-07")
    );

  const fetchAllPages = async () => {
    if (!queryResult.data?.collections?.pageInfo.hasNextPage) return;
    let hasNextPage: boolean =
      queryResult.data?.collections?.pageInfo.hasNextPage ?? false;
    let endCursor: string | null | undefined =
      queryResult.data?.collections?.pageInfo.endCursor;

    while (hasNextPage && endCursor) {
      const result = await queryResult.fetchMore({
        variables: { endCursor },
      });

      hasNextPage = result.data?.collections?.pageInfo.hasNextPage ?? false;
      endCursor = result.data?.collections?.pageInfo.endCursor;
    }
  };
  useEffect(() => {
    if (!queryResult.loading && queryResult.data) {
      void fetchAllPages();
    }
  }, [queryResult.loading, queryResult.data]);

  return queryResult.data;
}
